var _path, _path2, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeeklyReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 80,
    viewBox: "0 0 123 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.769 60C113.9 57.7855 114.545 55.2366 114.545 52.5317C114.545 43.9116 108.023 36.9263 99.9743 36.9263C98.1564 36.9263 96.4288 37.2979 94.826 37.9518C93.126 26.8349 84.1199 18.3485 73.2611 18.3485C71.7139 18.3485 63.495 18.3485 59.0658 24.665C56.2976 9.49506 49.12 2 39.309 2C27.6246 2 18.1466 12.1435 18.1466 24.665C18.1466 24.7913 18.1536 24.9176 18.1536 25.0514C8.66864 26.9612 1.4873 35.8785 1.4873 46.5868C1.4873 51.64 3.08316 56.2919 5.76835 60H112.769Z",
    fill: "#EDF1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 74.5C23.364 72.1678 60.3837 69 57.8797 50.3377C55.7465 34.4388 35.0423 42.5751 38.2953 55.6718C40.6325 65.0812 66.6155 80.4079 86.696 40.5485",
    stroke: "#F7D064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8032_60347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0908 29.9101L71.9314 42.0021L118.137 9.26562L49.0908 29.9101Z",
    fill: "url(#paint0_linear_8032_60347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9336 42.0021V62.7926L118.139 9.26562L71.9336 42.0021Z",
    fill: "url(#paint1_linear_8032_60347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6127 46.184L72.734 60.2764C72.524 60.7798 73.1829 61.1878 73.5399 60.7754L118.137 9.26562L78.6127 46.184Z",
    fill: "#137BC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9647 60.3727L78.8227 46.3299L114.86 12.6688L73.3509 60.6118C73.1798 60.8094 72.8641 60.6139 72.9647 60.3727Z",
    stroke: "#F9FDFF",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6123 46.184L104.559 60.4736L118.137 9.26562L78.6123 46.184Z",
    fill: "url(#paint2_linear_8032_60347)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8032_60347",
    x: 45.0908,
    y: 9.26562,
    width: 77.0479,
    height: 61.5273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.43917 0 0 0 0 0.595833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8032_60347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8032_60347",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8032_60347",
    x1: 124.671,
    y1: 51.383,
    x2: 116.766,
    y2: 1.47405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8032_60347",
    x1: 107.34,
    y1: 6.60367,
    x2: 78.7772,
    y2: 75.9746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#73B8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8032_60347",
    x1: 121.877,
    y1: 75.1476,
    x2: 92.7066,
    y2: 7.7436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFAFE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyReports);
export default __webpack_public_path__ + "static/media/weekly_reports.9026b838386fa138844653a54c5aba5d.svg";
export { ForwardRef as ReactComponent };